import PocketBase from 'pocketbase';

// URL del backend PocketBase self-hosted su aaPanel (*.wawave.org)
// 100% Gratuito per sempre, zero limiti di progetti, zero pause di inattività
const POCKETBASE_URL = import.meta.env.VITE_POCKETBASE_URL || 'https://pb.wawave.org';

export const pb = new PocketBase(POCKETBASE_URL);

// Disabilita auto-cancellation per evitare che richieste concorrenti si annullino a vicenda
pb.autoCancellation(false);

/**
 * Ottiene il ristorante_id corrente con risoluzione ibrida e persistenza automatica:
 * 1. Parametro URL esplicito (es. ?r=ristorante-1 o #/cassa?r=ristorante-1)
 * 2. Valore salvato in sessionStorage / localStorage (mantiene il contesto tra le pagine)
 * 3. Fallback da ambiente Vite VITE_RESTAURANT_ID o 'ristorante-1'
 */
export const getRestaurantId = () => {
  try {
    // 0. Rilevamento automatico da sottodominio (es. nomeristorante.tap2order.dynamic-web.space)
    if (typeof window !== 'undefined' && window.location.hostname) {
      const host = window.location.hostname.toLowerCase();
      if (host.includes('.tap2order.')) {
        const sub = host.split('.tap2order.')[0].trim();
        if (sub && sub !== 'www' && sub !== 'tap2order') {
          sessionStorage.setItem('tap2order_active_restaurant', sub);
          localStorage.setItem('tap2order_active_restaurant', sub);
          return sub;
        }
      }
    }

    // 1. Cerca nei searchParams standard
    const searchParams = new URLSearchParams(window.location.search);
    const rFromSearch = searchParams.get('r');
    if (rFromSearch) {
      sessionStorage.setItem('tap2order_active_restaurant', rFromSearch);
      localStorage.setItem('tap2order_active_restaurant', rFromSearch);
      return rFromSearch;
    }

    // 2. Cerca nella query dell'hash router (#/cucina?r=ristorante-1)
    if (window.location.hash && window.location.hash.includes('?')) {
      const hashQuery = window.location.hash.split('?')[1];
      const hashParams = new URLSearchParams(hashQuery);
      const rFromHash = hashParams.get('r');
      if (rFromHash) {
        sessionStorage.setItem('tap2order_active_restaurant', rFromHash);
        localStorage.setItem('tap2order_active_restaurant', rFromHash);
        return rFromHash;
      }
    }

    // 3. Recupera dalla sessione precedente se non specificato nell'URL
    const savedSession = sessionStorage.getItem('tap2order_active_restaurant');
    if (savedSession) return savedSession;

    const savedLocal = localStorage.getItem('tap2order_active_restaurant');
    if (savedLocal) return savedLocal;
  } catch (e) {
    // browser env fallback
  }

  // Fallback primario su 'ristorante-1' (compatibile con comande default)
  return import.meta.env.VITE_RESTAURANT_ID || 'ristorante-1';
};

/**
 * Genera la query string per preservare il ristorante attivo nei link di navigazione
 */
export const getRestaurantQuery = () => {
  const r = getRestaurantId();
  return r ? `?r=${encodeURIComponent(r)}` : '';
};

export default pb;
